import { useCallback, useEffect, useRef } from 'react'

type Props = {
  onBackClick?: () => void
  onForwardClick?: () => void
}
export const useBrowserNavigation = ({ onBackClick, onForwardClick }: Props) => {
  const indexRef = useRef(0)

  const handleStateChange = useCallback(
    (e: PopStateEvent) => {
      const next = e.state?.index ?? 0

      if (next < indexRef.current) {
        onBackClick?.()
      }

      if (next > indexRef.current) {
        onForwardClick?.()
      }

      indexRef.current = next
    },
    [onBackClick, onForwardClick]
  )

  const pushBrowserState = () => {
    indexRef.current++
    window.history.pushState({ index: indexRef.current }, '')
  }

  useEffect(() => {
    window.history.replaceState({ index: indexRef.current }, '')

    window.addEventListener('popstate', handleStateChange)

    return () => {
      window.removeEventListener('popstate', handleStateChange)
    }
  }, [handleStateChange])

  return {
    pushBrowserState,
  }
}
